import { TransferPricingDocumentationRequestHelper } from './transfer-pricing-documentation-request-helper';
import type {
  IChangeTransferPricingDocumentationStatusParams,
  ITransferPricingDocumentationRecordResponse,
  TTransferPricingDocumentationMutationResult,
} from './types';

const FALLBACK_ERROR_MESSAGE = 'Could not change the status. Please try again.';

export const changeTransferPricingDocumentationStatus = (
  documentationId: string,
  params: IChangeTransferPricingDocumentationStatusParams,
  token?: string
): Promise<
  TTransferPricingDocumentationMutationResult<ITransferPricingDocumentationRecordResponse>
> =>
  TransferPricingDocumentationRequestHelper.send({
    path: `${TransferPricingDocumentationRequestHelper.recordPath(documentationId)}/status`,
    method: 'POST',
    body: { ...params },
    isExpectedBody: TransferPricingDocumentationRequestHelper.hasDocumentation,
    fallbackErrorMessage: FALLBACK_ERROR_MESSAGE,
    token,
  });
